import React from 'react'
import styled from 'styled-components'
import liveScreenBackground from '../../assets/liveScreen/liveScreenBackground.jpg'

import Loader from '../Loader/Loader.tsx'

export const SplashScreenContainer = styled.div`
  width: 100%;
  height: 100vh;
  /* background: url(${liveScreenBackground});
  background-size: contain;
  background-repeat: no-repeat; */
`

export const BackgroundMask = styled.div`
  width: 100%;
  height: 100%;
  opacity: 0.75;
  top: 0;
  position: fixed;
  background: rgb(250, 173, 2);
  background: linear-gradient(
    0deg,
    rgba(52, 33, 82, 1) 0%,
    rgba(52, 33, 82, 1) 37%,
    rgba(120, 23, 154, 0.9724264705882353) 69%,
    rgba(52, 33, 82, 1) 92%,
    rgba(52, 33, 82, 1) 100%
  );
`

const SplashScreen = ({ isLoading }) => {
  return (
    <SplashScreenContainer>
      {isLoading && <Loader />}
      <BackgroundMask />
    </SplashScreenContainer>
  )
}

export default SplashScreen
